// we are in development if the host is localhost
const IN_DEV = window.location.host.startsWith('localhost');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debuglog = (...message: any[]) => {
  if (IN_DEV) {
    console.log(...message);
  }
};